(() => {
  function initialiseLiveViewers(root = document) {
    const viewerBlocks = root.querySelectorAll('[data-live-viewers]');

    viewerBlocks.forEach((block) => {
      // Prevent the same block being initialised twice
      if (block.dataset.liveViewersInitialised === 'true') return;

      const productId = block.dataset.productId;
      const min = parseInt(block.dataset.viewerMin, 10);
      const max = parseInt(block.dataset.viewerMax, 10);
      const countElement = block.querySelector('[data-live-viewer-count]');

      if (
        !productId ||
        Number.isNaN(min) ||
        Number.isNaN(max) ||
        !countElement ||
        min > max
      ) {
        return;
      }

      block.dataset.liveViewersInitialised = 'true';

      const storageKey = `h2o-live-viewers-${productId}`;

      let currentCount = getStoredCount();

      // Pick a new starting number if this visitor has not
      // already viewed this product during their session.
      if (
        currentCount === null ||
        currentCount < min ||
        currentCount > max
      ) {
        currentCount = randomBetween(min, max);
        storeCount(currentCount);
      }

      updateDisplay();
      block.hidden = false;

      scheduleNextChange();

      function scheduleNextChange() {
        // Random delay of 45 to 90 seconds
        const delay = randomBetween(45000, 90000);

        window.setTimeout(() => {
          // Don't alter the figure while the browser tab is hidden.
          if (!document.hidden) {
            const change = chooseDrift();

            currentCount = clamp(
              currentCount + change,
              min,
              max
            );

            storeCount(currentCount);
            updateDisplay();
          }

          scheduleNextChange();
        }, delay);
      }

      function chooseDrift() {
        // Small movements are deliberately much more common.
        // Zero means the value sometimes stays unchanged.
        const possibilities = [
          -2,
          -1,
          -1,
          0,
          0,
          0,
          1,
          1,
          2
        ];

        return possibilities[
          Math.floor(Math.random() * possibilities.length)
        ];
      }

      function updateDisplay() {
        countElement.textContent = currentCount;
      }

      function getStoredCount() {
        try {
          const stored = sessionStorage.getItem(storageKey);

          if (stored === null) return null;

          const parsed = parseInt(stored, 10);
          return Number.isNaN(parsed) ? null : parsed;
        } catch (error) {
          return null;
        }
      }

      function storeCount(value) {
        try {
          sessionStorage.setItem(storageKey, String(value));
        } catch (error) {
          // The counter can still work if browser storage is unavailable.
        }
      }

      function randomBetween(minimum, maximum) {
        return Math.floor(
          Math.random() * (maximum - minimum + 1)
        ) + minimum;
      }

      function clamp(value, minimum, maximum) {
        return Math.min(
          Math.max(value, minimum),
          maximum
        );
      }
    });
  }

  // Normal storefront page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialiseLiveViewers();
    });
  } else {
    initialiseLiveViewers();
  }

  // Also makes it behave properly inside Shopify's Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    initialiseLiveViewers(event.target);
  });
})();